import {
  isComparisonMode,
  isNotComparisonMode,
  showAllComparisonMode,
} from '../utils/comparison-mode-options'
import { filters } from '../constants'
import { workflowFilterLabel } from './shared'

export const workflowUsageDefinition = {
  type: filters.WORKFLOW_USAGE,
  nameKey: 'workflow_usage',

  getColumnSubtitle(settings, getters) {
    return workflowFilterLabel(settings, getters)
  },

  comparisonModes() {
    return [
      ...isComparisonMode({
        customLabel: I18n.t(
          'companies_overview.filters.workflow_usage.is_present'
        ),
      }),
      ...isNotComparisonMode({
        customLabel: I18n.t(
          'companies_overview.filters.workflow_usage.is_not_present'
        ),
      }),
      ...showAllComparisonMode(),
    ]
  },
  serializeSettings(settings) {
    const { comparisonMode, firmWorkflowId, partnerWorkflowId } = settings

    return {
      comparison_mode: comparisonMode,
      firm_workflow_id: firmWorkflowId,
      partner_workflow_id: partnerWorkflowId,
    }
  },

  deserializeSettings(params) {
    return {
      comparisonMode: params.comparison_mode,
      firmWorkflowId: params.firm_workflow_id,
      partnerWorkflowId: params.partner_workflow_id,
    }
  },

  activeSubtitle(settings, getters) {
    const { comparisonMode } = settings

    const workflowLabel = workflowFilterLabel(settings, getters)
    // archived workflow
    if (!workflowLabel) {
      return
    }
    const comparisonModeLabel = this.comparisonModes().find(
      (mode) => mode.value === comparisonMode
    ).label

    return `${workflowLabel} ${comparisonModeLabel}`
  },
}
